import React, {useEffect} from 'react';
import "./request-quote.scss";

function RequestQuote() {
  return  (
    <div className="request-quote__border">
      <div className="notify-me__title-box">
        How To Get It
      </div>   
      <span>
        You have selected to have this item installed, so it isn't available to add to your cart for pickup or for delivery.
      </span>
    </div>
  );
}

export default RequestQuote;
